import React, { useState, useEffect, useRef, useContext } from 'react';
import { AuthContext } from "../../context/AuthContext";
import "./ChatWidget.scss";
import apiRequest from '../../lib/apiRequest';

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { role: 'bot', text: 'Greetings! How can I help you today?' }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const { currentUser } = useContext(AuthContext);
  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading]); // Added loading to trigger scroll when typing indicator shows

  const handleSend = async (e) => {
    e.preventDefault();
    if (!input.trim() || loading) return;

    const userText = input.trim();
    setMessages(prev => [...prev, { role: 'user', text: userText }]);
    setInput('');
    setLoading(true);

    try {
      const res = await apiRequest.withConfig(false).post(
        "/chats/chatbot", 
        {
          message: userText,
          session_id: currentUser?.id || "guest_user"
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          }
        }
      );

      if (res.data && res.data.reply) {
          setMessages(prev => [...prev, { role: 'bot', text: res.data.reply }]);
      } else {
          setMessages(prev => [...prev, { role: 'bot', text: "I received an empty response from the server." }]);
      }
    } catch (err) {
      console.error("API Error:", err.response?.data || err.message);
      setMessages(prev => [...prev, { role: 'bot', text: "Service temporarily unavailable." }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="chatbot-fixed-container">
      {isOpen ? (
        <div className="chat-window">
          <div className="chat-header">
            <span>Bhoomi AI ChatBot</span>
            <button onClick={() => setIsOpen(false)}>×</button>
          </div>
          <div className="chat-body">
            {messages.map((m, i) => (
              <div key={i} className={`bubble-container ${m.role}`}>
                <div className="bubble">{m.text}</div>
              </div>
            ))}
            {loading && (
              <div className="bubble-container bot">
                <div className="bubble typing">Bot is typing...</div>
              </div>
            )}
            <div ref={chatEndRef} />
          </div>
          <form className="chat-footer" onSubmit={handleSend}>
            <input 
              value={input} 
              onChange={e => setInput(e.target.value)}
              placeholder="Ask about plans..." 
              disabled={loading} // Optional: disable input while loading
            />
            {/* ✅ Button is disabled while loading */}
            <button type="submit" disabled={loading || !input.trim()}>
              {loading ? "..." : "Send"}
            </button>
          </form>
        </div>
      ) : (
        <button className="launcher" onClick={() => setIsOpen(true)}>
          💬 Help
        </button>
      )}
    </div>
  );
};

export default ChatWidget;